import type { ReactNode } from 'react';
import './fact-list.css';

export interface FactListProps {
  children: ReactNode;
}

/** Inset group of immutable labels and values. */
export function FactList({ children }: FactListProps) {
  return <div className="factList">{children}</div>;
}

export interface FactItemProps {
  label: ReactNode;
  children: ReactNode;
}

/** One labelled, read-only fact inside a FactList. */
export function FactItem({ label, children }: FactItemProps) {
  return (
    <div className="factItem">
      <span className="factLabel">{label}</span>
      <span className="factValue">{children}</span>
    </div>
  );
}

export interface IdentifierProps {
  children: ReactNode;
}

/** Compact identifier value such as a partner slug or stored tag. */
export function Identifier({ children }: IdentifierProps) {
  return <code className="identifier">{children}</code>;
}
